export const stripHighlightTags = (s?: string | null): string => (s ?? '').replace(/<\/?b>/gi, '')
